import Button from "components/buttonNew/button";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";

import type { Breakfast } from "../../types";

type PromoBlockProps = Pick<
  Breakfast,
  | "bottomPromoBlockHeading"
  | "bottomPromoBlockCtaLabel"
  | "bottomPromoBlockCtaUrl"
>;

const PromoBlock = ({
  bottomPromoBlockHeading,
  bottomPromoBlockCtaLabel,
  bottomPromoBlockCtaUrl,
}: PromoBlockProps) => {
  const { track } = useMixpanelTracking();

  const handleClickOnCta = async () => {
    await track("Breakfast detail promo block click", {
      "Click link": bottomPromoBlockCtaUrl,
      "Click text": bottomPromoBlockCtaLabel,
    });
  };

  return (
    <div className={"flex flex-col text-center text-black-rock"}>
      <p className={"mb-5 font-recklessBold text-[26px] leading-[130%]"}>
        {bottomPromoBlockHeading}
      </p>
      <div>
        <Button
          size={"medium"}
          component={"link"}
          target={"_blank"}
          href={bottomPromoBlockCtaUrl}
          onClick={handleClickOnCta}
        >
          {bottomPromoBlockCtaLabel}
        </Button>
      </div>
    </div>
  );
};

export default PromoBlock;
